import { create } from "zustand";
import type { EditorState } from "@/domain/vim/model/editor-state";

/**
 * エディタの状態を保持するストア。演習未開始時は `null`。
 *
 * NFR-002（キー入力から画面反映まで16ms以下）のための規則: このストアはキー1打ごとに
 * 更新される最高頻度のストアである。利用側は `EditorState` 全体ではなく、
 * セレクタで必要なプリミティブ値のみを購読すること（例: `state.editorState?.cursor` ではなく
 * `state.editorState?.mode` や `state.editorState?.usedKeystrokes` のような値単位の購読）。
 * `EditorState` 全体を購読するコンポーネントを作らない。
 */
export interface EditorStore {
  readonly editorState: EditorState | null;
  readonly setEditorState: (state: EditorState) => void;
}

export const useEditorStore = create<EditorStore>((set) => ({
  editorState: null,
  setEditorState: (state) => set({ editorState: state }),
}));
